import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromGroupsOfGroup from './groups-of-group.reducer';
import { GroupsOfGroupState } from './groups-of-group.state';
import { GroupsOfGroup } from '@era/security-sdk';
import { selectCurrentUserId } from '../router/security-router.selector';

export const selectGroupsOfGroupState = createFeatureSelector<GroupsOfGroupState>('groupsOfGroups');

export const selectAllGroupsOfGroups = createSelector(selectGroupsOfGroupState, fromGroupsOfGroup.selectAllGroups);

export const selectParentGroups = (groupId: string) =>
  createSelector(selectAllGroupsOfGroups, (memberGroups: GroupsOfGroup[]) =>
    memberGroups ? memberGroups.filter((group) => group.groupId === groupId) : []
  );

export const selectParentGroupNames = (groupId: string) =>
  createSelector(selectParentGroups(groupId), (memberGroups: GroupsOfGroup[]) =>
    memberGroups ? memberGroups.map((group) => group.name) : []
  );

export const selectParentGroupIds = (groupId: string) =>
  createSelector(selectParentGroups(groupId), (memberGroups: GroupsOfGroup[]) =>
    memberGroups ? memberGroups.map((group) => group.parentGroupId) : []
  );

export const selectCurrentUserMembership = createSelector(
  selectCurrentUserId,
  selectAllGroupsOfGroups,
  (currentUserId: string, groupsOfGroups: GroupsOfGroup[]) =>
    currentUserId && groupsOfGroups ? groupsOfGroups.filter((group) => group.groupId === currentUserId) : []
);

export const selectUserMembership = (groupId: string) =>
  createSelector(selectAllGroupsOfGroups, (groupsOfGroups: GroupsOfGroup[]) =>
    groupId && groupsOfGroups ? groupsOfGroups.filter((group) => group.groupId === groupId) : []
  );
